import * as React from "react";
import { SVGProps } from "react";
function SvgPlayerPlayIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10 6.25v17.5L23.75 15 10 6.25Z" fill="#000" />
    </svg>
  );
}
export default SvgPlayerPlayIcon;
